import { render, staticRenderFns } from "./materialText.vue?vue&type=template&id=6e317750&"
import script from "./materialText.vue?vue&type=script&lang=js&"
export * from "./materialText.vue?vue&type=script&lang=js&"
import style0 from "./materialText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports